import {
USER_TOKEN,
CURRENT_USER_INFO,
PARAMS,
ADD_PUBLISHERS_STATES,
CURRENT_PUBLISHER_ID,
CURRENT_PUBLISHER_SIMPLE,
LANGUAGE,
} from "../store/mutation-types";
import { default as store, clear } from "../store/index";
import {
login as apphiLoginRes,
register as registerRes,
createPubliships as createPublishipsRes,
delPubliships as delPublishipsRes,
bulkCreateMember as bulkCreateMemberRes,
bulkModifyMember as bulkModifyMemberRes,
delMember as delMemberRes,
delMemberships as delMembershipsRes,
modifyMember as modifyMemberRes,
mulModifyUnlimited as mulModifyUnlimitedRes,
} from "../apis/users";
import { active } from "../apis/post";
import { login as instagramLoginRes } from "../apis/publisher";
import base64 from 'vux/src/tools/base64/index.js'

import { getCurrentCountry, list as planList, UserPlan } from "./plans";
import Raven from "raven-js";
import moment from "moment";
import Vue from "vue";

/**
* 通过app跳转进行免登操作
* @param params app传递参数
*/
export async function autoLogin({ params }) {

clear();

Vue.i18n.set(params.accept_language);
console.log(
"paramsparamsparamsparams",
params.support_iap,
params.support_iap === "1"
);

if (params.accept_language) {
store.commit(LANGUAGE, params.accept_language);
const language = store.getters[LANGUAGE];
Vue.i18n.set(language);
moment.locale(language);
}

const token = params.auth;

store.commit(USER_TOKEN, token);
let headers = {
publisherId: params.publisher_id,
advertisingId: params.advertising_id,
limitAdTracking: params.limit_ad_tracking,
appsFlyerId: params.appsflyer_id,
fireBaseVersion: params.firebase_version,
userAgent: params.useragent,
timestamp: params.timestamp, // 只为web服务
};

if (params.support_iap !== undefined) {
headers.supportIap = params.support_iap;
}

if (params.support_iap === "1") {

const { country } = await getCurrentCountry();
headers.country = country;
}

store.commit(PARAMS, headers);
await updateUserInfo({});

await planList();

store.commit(CURRENT_PUBLISHER_ID, params.publisher_id);
}

/**
* apphi用户登录
* @param email 用户名
* @param password 密码
* @returns {Promise<void>}
*/
export async function apphiLogin({ email, password }) {
clear();
const encode = base64.encode(`${email}:${password}`);
const { data: user } = await apphiLoginRes({
basic: `${encode}`,
ignoreToken: true,
with_stripe: true,
});
await initUserInfo(user);
if (user.publiships.length === 0) {
store.commit(CURRENT_PUBLISHER_ID, "");
} else {

store.commit(CURRENT_PUBLISHER_ID, user.publiships[0].publisher.id);
}

await planList();
return user;
}
/**
* 注册用户
* @param email 用户名
* @param password 密码
* @returns {Promise<void>}
*/
export async function register({ email, password }) {
const { data: user } = await registerRes({ email, password });
return user;
}
/**
* 更新当前登录人用户信息
* @param withStripe 是否获取信用卡信息
* @returns {Promise.<*>}
*/
export async function updateUserInfo({ withStripe = false }) {
const { data: user } = await apphiLoginRes({
ignoreToken: false,
with_stripe: withStripe,
});
await initUserInfo(user);
return user;
}

/**
* 当登录或者免登时重置本地缓存用户信息
* @param user
*/
export async function initUserInfo(user) {
console.log("更新用戶", user);

store.commit(USER_TOKEN, user.auth);

store.commit(CURRENT_USER_INFO, user);
console.log("更新用户信息", user);

Raven.setUserContext({
email: user.email,
});
}

/**
* apphi用户登录
* @param email 用户名
* @param password 密码
* @returns {Promise<void>}
*/
export async function instagramLogin({ username, password }) {
const user = await instagramLoginRes({ username, password });
return user;
}

/**
*  与指定 publisher 建立绑定关系。
* @param username Instagram 用户名
* @param password Instagram 密码
* @returns {Promise<void>}
*/
export async function createPubliships({ username, password }) {
const { data: publiships } = await createPublishipsRes({
publisher_username: username,
publisher_password: password,
});
await updateUserInfo({});
return publiships;
}

/**
*  与指定 publisher 建立绑定关系。
* @param username Instagram 用户名
* @param password Instagram 密码
* @returns {Promise<void>}
*/
export async function createPublishipsByCode({
username,
password,
path,
code,
}) {
const { data: publiships } = await createPublishipsRes({
publisher_username: username,
publisher_password: password,
validation_api_path: path,
validation_code: code,
});
await updateUserInfo({});
return publiships;
}

/**
* 批量绑定publisher到member
* @param member_email member email
* @param publisher_ids publisher id，多个以逗号分隔。
* @returns {*}
*/
export async function bulkCreateMember({ email, ids }) {
const { data } = await bulkCreateMemberRes({
member_email: email,
publisher_ids: ids.toString(),
});
await updateUserInfo({});
return data;
}

/**
* 解除publiship关系
* @param pk publiship标识
* @returns {*}
*/
export async function delPubliships({ pk }) {
const { data } = await delPublishipsRes({ pk });
await updateUserInfo({});
return data;
}

/**
* 批量绑定unlimited 用户
* @param ids 用户id
* @param is_premium 是否限制为unlimted用户
* @returns {*}
*/
export async function mulModifyUnlimited({ ids, isPremium = true }) {
const { data } = await mulModifyUnlimitedRes({
ids: ids.toString(),
is_premium: isPremium,
});
await updateUserInfo({});
return data;
}

/**
* Publisher
*/
export class Publisher {
constructor(vo) {
this.id = vo.id;


this.image = vo.publisher.social_profile_picture;

this.username = vo.publisher.social_username;

this.publisherId = vo.publisher.id;

this.description = Vue.i18n.translate("activePage.freeUserDes", {
num: vo.autopost_remaining,
});
if (vo.is_premium) {

this.description = Vue.i18n.translate("activePage.unlimitedUserDes");
}

this.autopostRemaining = Number(vo.autopost_remaining);

this.isUnlimited = vo.is_premium;

this.isMember = vo.linked_as === 2;

this.status = vo.publisher.status;

if (Number(this.status) !== 1) {
store.commit(ADD_PUBLISHERS_STATES, {
id: this.publisherId,
status: this.isMember === 2 ? "me" : "login", // 如果是member用户则弹出让admin用户点击is me提示，其他情况让其重新验证ins账户
});
if (this.status === 2) {

this.description = null;
}
}


this.wasPremium = false; 
this.socialNetwork = vo.publisher.social_network; 
}

/**
* 激活用户所有post
* @returns {Promise<boolean>}
*/
async postActive() {
const { data } = await active({ publisherId: this.publisherId });
const success = data.failure_count === 0;
let newStatus = "success";

if (!success) {
newStatus = store.getters[CURRENT_PUBLISHER_SIMPLE].isMember
? "memberLimit"
: "normalLimit";
} else {

if (AndroidWebView && AndroidWebView.closeWebView) {

AndroidWebView.closeWebView(0); 
} else {
window.location.href = "apphi-post://";
}
}

store.commit(ADD_PUBLISHERS_STATES, {
id: this.publisherId,
status: newStatus,
});
await updateUserInfo({});
return success;
}
}

/**
* 当前登录人用户实体
*/
export class User {
constructor(user) {
if (!user) {
return;
}

this.id = user.id;

this.email = user.email;

this.premiumPublisherRemaining = Number(user.premium_publisher_remaining);
this.premiumInstagramRemaining = Number(user.premium_instagram_remaining);
this.premiumFacebookRemaining = Number(user.premium_facebook_remaining);
this.premiumTwitterRemaining = Number(user.premium_twitter_remaining);

this.memberRemaining = Number(user.member_remaining);

this.paymentMethod = user.subscription.payment_method;
if (user.subscription.plan.price === 0) {
this.paymentMethod = 0;
}

this.linkedInstagramList = user.publiships.map((p) => {
return new LinkInstagram(p);
});

this.teamMemberList = user.memberships.map((p) => new TeamMember(p));

this.plan = new UserPlan(user.subscription);

if (!user.credit_card) {
this.creditCard = "**** **** **** ****";
} else {
this.creditCard = user.credit_card;
}

this.name = user.name;

this.hasDiscount = user.has_discount;

this.existPaypalSubscription = user.exist_paypal_subscription;

this.unsubscription = user.limited_time_offers.unsubscription;

if (
user.subscription.external_data &&
user.subscription.external_data.purchase_token
) {
this.purchase_token = user.subscription.external_data.purchase_token;
}
}
}

export class LinkInstagram extends Publisher {
constructor(vo) {
super(vo);

this.member = vo.admin_email;
}

/**
* 删除当前 Publiship
*/
async remove() {

await delPublishipsRes({ pk: this.id });
await updateUserInfo({});








}

/**
* 移除当前用户unlimited状态
* @returns {Promise<void>}
*/
async removeUnlimited() {
await mulModifyUnlimited({ ids: [this.id], isPremium: false });
}

/**
* 更新当前用户为unlimited状态
* @returns {Promise<void>}
*/
async updateUnlimited() {
await mulModifyUnlimited({ ids: [this.id], isPremium: true });
}
}

export class TeamMember {
constructor(teamMember) {
this.id = teamMember.member_id;
this.adminEmail = teamMember.admin_email;
this.memberEmail = teamMember.member_email;
this.publishers = teamMember.publiships.map(
(vo) => new TeamMemberPublisher({ vo, memberId: this.id })
);
}

/**
* 删除对应member
*/
async remove() {

await delMemberRes({ id: this.id });
await updateUserInfo({});








}

/**
* 修改当前member的email
* @param email 邮箱
* @returns {Promise<void>}
*/
async modifyEmail({ email }) {
const { data } = await modifyMemberRes({
memberId: this.id,
new_member_email: email,
});
await updateUserInfo({});





return data.member_id;
}

/**
* 批量修改绑定的publisher
* @param ids
* @returns {Promise<void>}
*/
async mulModifyPublisher({ ids }) {
const publishers = await bulkModifyMemberRes({
memberId: this.id,
publisher_ids: ids.toString(),
});
await updateUserInfo({});





return publishers;
}
}

export class TeamMemberPublisher extends Publisher {
constructor({ vo, memberId }) {
super(vo);
this.memberId = memberId;
}

/**
* 删除member中对应 publisher
* @returns {Promise<void>}
*/
async remove() {
await delMembershipsRes({ memberId: this.memberId, pk: this.id });
await updateUserInfo({});











}
}



// WEBPACK FOOTER //
// ./src/services/users.js